import { Box } from "@mui/joy";
import { createFileRoute } from "@tanstack/react-router";

import TaskSetDetailSidebar from "@/components/TaskSetDetailSidebar/TaskSetDetailSidebar";

const Component = () => {
  const uuid = Route.useParams().setUuid;
  const navigate = Route.useNavigate();
  return (
    <Box sx={{ height: "100dvh" }}>
      <TaskSetDetailSidebar
        uuid={uuid}
        onClose={() => {
          navigate({
            from: Route.fullPath,
            to: "..",
          });
        }}
      />
    </Box>
  );
};

export const Route = createFileRoute("/gym/$venueUuid/schedule/set/$setUuid/edit")({
  component: Component,
});
